module.exports = __webpack_public_path__ + "static/media/SCOPE.jpg-s.f4afaa59.webp";